const SITE_NAME = 'APC Plus';
const LEGAL_NAME = 'APC TECHNOLOGY SDB BHD';
const LANDING_URL = 'https://apcplus.xyz/';
const OG_IMAGE = 'https://apcplus.xyz/APC-Plus.png';
const IMAGE_ALT = 'APC Plus — your Credits, ready for more.';
const ROBOTS = 'index, follow, max-image-preview:large';
const SCHEMA_ID = 'apc-landing-schema';

function upsertMeta(selector, attributes) {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('meta');
        document.head.appendChild(element);
    }
    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
}

function upsertLink(rel, href) {
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
}

function upsertJsonLd(htmlLang) {
    let element = document.getElementById(SCHEMA_ID);
    if (!element) {
        element = document.createElement('script');
        element.id = SCHEMA_ID;
        element.type = 'application/ld+json';
        document.head.appendChild(element);
    }

    element.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'Organization',
                '@id': 'https://apcplus.xyz/#organization',
                name: LEGAL_NAME,
                alternateName: SITE_NAME,
                url: LANDING_URL,
                logo: {
                    '@type': 'ImageObject',
                    url: 'https://apcplus.xyz/assets/apc-plus-icon.png',
                    width: 4500,
                    height: 4500,
                },
                email: 'mailto:info@apcplus.xyz',
                contactPoint: {
                    '@type': 'ContactPoint',
                    contactType: 'customer support',
                    email: 'info@apcplus.xyz',
                    availableLanguage: 'English',
                },
                brand: {
                    '@type': 'Brand',
                    name: SITE_NAME,
                },
            },
            {
                '@type': 'WebSite',
                '@id': 'https://apcplus.xyz/#website',
                url: LANDING_URL,
                name: SITE_NAME,
                description: 'Shop, earn, send, and manage your Credits with APC Plus.',
                publisher: {
                    '@id': 'https://apcplus.xyz/#organization',
                },
                inLanguage: htmlLang,
            },
        ],
    });
}

export function applyMetadata({ title, description, htmlLang, ogLocale }) {
    document.title = title;
    document.documentElement.lang = htmlLang;

    upsertMeta('meta[name="description"]', { name: 'description', content: description });
    upsertMeta('meta[name="application-name"]', { name: 'application-name', content: SITE_NAME });
    upsertMeta('meta[name="apple-mobile-web-app-title"]', {
        name: 'apple-mobile-web-app-title',
        content: SITE_NAME,
    });
    upsertMeta('meta[name="author"]', { name: 'author', content: LEGAL_NAME });
    upsertMeta('meta[name="robots"]', { name: 'robots', content: ROBOTS });
    upsertMeta('meta[name="theme-color"]', { name: 'theme-color', content: '#050d1a' });
    upsertMeta('meta[name="color-scheme"]', { name: 'color-scheme', content: 'dark' });
    upsertMeta('meta[name="format-detection"]', { name: 'format-detection', content: 'telephone=no' });
    upsertMeta('meta[name="referrer"]', { name: 'referrer', content: 'strict-origin-when-cross-origin' });

    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE_NAME });
    upsertMeta('meta[property="og:locale"]', { property: 'og:locale', content: ogLocale });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: LANDING_URL });
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: OG_IMAGE });
    upsertMeta('meta[property="og:image:secure_url"]', { property: 'og:image:secure_url', content: OG_IMAGE });
    upsertMeta('meta[property="og:image:type"]', { property: 'og:image:type', content: 'image/png' });
    upsertMeta('meta[property="og:image:width"]', { property: 'og:image:width', content: '5000' });
    upsertMeta('meta[property="og:image:height"]', { property: 'og:image:height', content: '1517' });
    upsertMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: IMAGE_ALT });

    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: OG_IMAGE });
    upsertMeta('meta[name="twitter:image:alt"]', { name: 'twitter:image:alt', content: IMAGE_ALT });

    upsertLink('canonical', LANDING_URL);
    upsertJsonLd(htmlLang);
}
